import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/Layout';
import LabLanding from './pages/LabLanding';
import AgencyHome from './pages/AgencyHome';
import ProjectDetail from './pages/ProjectDetail';
import About from './pages/About';
import Search from './pages/Search';
import Financing from './pages/Financing';
import ReformationsLanding from './pages/ReformationsLanding';
import CommunityManagement from './pages/CommunityManagement';
import Sell from './pages/Sell';
import CookiePolicy from './pages/CookiePolicy';
import Blog from './pages/Blog';
import ArticleDetail from './pages/ArticleDetail';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
    return (
        <LanguageProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <Layout>
                    <Routes>
                        {/* Rutas Principales de Marca */}
                        <Route path="/" element={<LabLanding />} />
                        <Route path="/studio" element={<LabLanding />} />
                        <Route path="/studio/proyecto/:slug" element={<ProjectDetail />} />
                        <Route path="/lab" element={<LabLanding />} />
                        <Route path="/lab/proyecto/:slug" element={<ProjectDetail />} />
                        <Route path="/agency" element={<AgencyHome />} />

                        <Route path="/about" element={<About />} />
                        <Route path="/search" element={<Search />} />
                        <Route path="/financing" element={<Financing />} />
                        <Route path="/renovation" element={<LabLanding />} />
                        <Route path="/reformas-landing" element={<LabLanding />} />

                        {/* Rutas SEO para reformas por ubicación (sin idioma) */}
                        <Route path="/empresa-reformas-:location" element={<ReformationsLanding />} />
                        <Route path="/reforma-integral-:location" element={<ReformationsLanding />} />
                        <Route path="/reforma-bano-:location" element={<ReformationsLanding />} />
                        <Route path="/reforma-cocina-:location" element={<ReformationsLanding />} />

                        {/* Rutas con prefijo de idioma - ESPAÑOL */}
                        <Route path="/es/reformas-valles-occidental" element={<ReformationsLanding />} />
                        <Route path="/es/empresa-reformas-:location" element={<ReformationsLanding />} />
                        <Route path="/es/reforma-integral-:location" element={<ReformationsLanding />} />
                        <Route path="/es/reforma-bano-:location" element={<ReformationsLanding />} />
                        <Route path="/es/reforma-cocina-:location" element={<ReformationsLanding />} />

                        {/* Rutas con prefijo de idioma - CATALÁN */}
                        <Route path="/ca/reformes-valles-occidental" element={<ReformationsLanding />} />
                        <Route path="/ca/empresa-reformes-:location" element={<ReformationsLanding />} />
                        <Route path="/ca/reforma-integral-:location" element={<ReformationsLanding />} />
                        <Route path="/ca/reforma-bany-:location" element={<ReformationsLanding />} />
                        <Route path="/ca/reforma-cuina-:location" element={<ReformationsLanding />} />

                        {/* Rutas con prefijo de idioma - INGLÉS */}
                        <Route path="/en/renovations-landing" element={<ReformationsLanding />} />
                        <Route path="/en/renovation-company-:location" element={<ReformationsLanding />} />
                        <Route path="/en/complete-renovation-:location" element={<ReformationsLanding />} />
                        <Route path="/en/bathroom-renovation-:location" element={<ReformationsLanding />} />
                        <Route path="/en/kitchen-renovation-:location" element={<ReformationsLanding />} />

                        {/* Rutas generales con prefijo de idioma */}
                        <Route path="/:lang/" element={<LabLanding />} />
                        <Route path="/:lang/studio" element={<LabLanding />} />
                        <Route path="/:lang/studio/proyecto/:slug" element={<ProjectDetail />} />
                        <Route path="/:lang/lab" element={<LabLanding />} />
                        <Route path="/:lang/lab/proyecto/:slug" element={<ProjectDetail />} />
                        <Route path="/:lang/agency" element={<AgencyHome />} />
                        <Route path="/:lang/about" element={<About />} />
                        <Route path="/:lang/search" element={<Search />} />
                        <Route path="/:lang/financing" element={<Financing />} />
                        <Route path="/:lang/renovation" element={<LabLanding />} />
                        <Route path="/:lang/community" element={<CommunityManagement />} />
                        <Route path="/:lang/sell" element={<Sell />} />
                        <Route path="/:lang/contact" element={<Contact />} />
                        <Route path="/:lang/blog" element={<Blog />} />
                        <Route path="/:lang/blog/:slug" element={<ArticleDetail />} />

                        <Route path="/community" element={<CommunityManagement />} />
                        <Route path="/sell" element={<Sell />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/agency/contact" element={<Contact service="agency" />} />
                        <Route path="/studio/contact" element={<Contact service="studio" />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<ArticleDetail />} />
                        <Route path="/politica-cookies" element={<CookiePolicy />} />
                        <Route path="/:lang/agency/contact" element={<Contact service="agency" />} />
                        <Route path="/:lang/studio/contact" element={<Contact service="studio" />} />
                        <Route path="/:lang/politica-cookies" element={<CookiePolicy />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Layout>
            </Router>
        </LanguageProvider>
    );
}

export default App;
